import type { ChipProps } from "@mui/material";
import { Chip, Typography } from "@mui/material";
import { FormattedMessage } from "react-intl";

export function BetaChip(props: Pick<ChipProps, "color" | "size" | "variant">) {
  return (
    <Chip
      size="small"
      {...props}
      label={
        <Typography variant="overline">
          <FormattedMessage id="Beta" />
        </Typography>
      }
    />
  );
}
